import { api } from "@contexts";
import { CompoundedPrescriptionDetails } from "@interfaces";

export interface CreateCompoundedPrescriptionParams {
  requestId: string;
  compoundedPrescriptionDetails: CompoundedPrescriptionDetails;
}

export async function createCompoundedPrescription({
  requestId,
  compoundedPrescriptionDetails,
}: CreateCompoundedPrescriptionParams): Promise<void> {
  if (!requestId) {
    throw new Error("createCompoundedPrescription: requestId is required");
  }

  const { compoundedIngredients } = compoundedPrescriptionDetails;
  await api({
    method: "post",
    url: `/requests/${requestId}/compounded-prescriptions`,
    data: {
      compoundedPrescriptionDetails,
      managementSummary: compoundedIngredients.trim(),
    },
  });
}
